module.exports = __webpack_public_path__ + "img/rekt.be517a17.png";